<style lang="less" scoped>
.btn-right-mes {
  margin-left: 10px;
  line-height: 32px;
}

.withdrawal-mes {
  margin: 0px 0px 16px 30px;
}

/deep/ .hide .el-upload--picture-card {
  display: none;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">电站分析</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">运营类别</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.isHostOperate"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              >
                <el-option label="自运营" value="02"></el-option>
                <el-option label="代运营" value="01"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">运营商名称</div>

            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.dealName"
                multiple
                clearable
                remote
                reserve-keyword
                filterable
                value-key="id"
                @change="getdealerArr"
                @keyup.enter.native="getListData(pagination, true)"
              >
                <el-option
                  v-for="item in dealerArr"
                  :key="item.id"
                  :label="item.dealName"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">电站名称</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.stationName"
                multiple
                clearable
                remote
                reserve-keyword
                filterable
                value-key="stationNo"
                no-data-text="暂无数据"
                @change="getSiteArr"
                @focus="getSiteAll"
                @keyup.enter.native="getListData(pagination, true)"
              >
                <el-option
                  v-for="item in siteArr"
                  :key="item.stationNo"
                  :label="item.stationName"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">时间范围</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                class="full-width"
                v-model="searchTime"
                :picker-options="pickerOptions"
                clearable
                style="width:340px;"
                type="daterange"
                size="small"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleDateChange"
              ></el-date-picker>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <el-radio-group v-model="queryInfo.yoy">
              <el-radio label="N">显示环比</el-radio>
              <el-radio label="Y">显示同比</el-radio>
            </el-radio-group>
          </div>
        </template>
        <template slot="actions">
          <button class="common-bg-button" @click="getSerech">
            筛选
          </button>
          <!-- <button class="common-empty-button" @click="reset()">重 置</button> -->
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <button
          class="common-bg-button"
          @click="handleQoq"
          style="margin-bottom:20px"
        >
          环比
        </button>
        <button
          class="common-bg-button"
          @click="handleYoy"
          style="margin-bottom:20px"
        >
          同比
        </button>
        <button
          class="common-bg-button"
          @click="handleExport"
          style="margin-bottom:20px"
        >
          导 出
        </button>
        <button
          class="common-bg-button"
          @click="handleDel"
          style="margin-bottom:20px"
        >
          删除
        </button>
        <!-- <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table> -->
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          stripe
          @selection-change="
            (sels) => {
              selections = sels;
            }
          "
        >
          <el-table-column type="selection" width="40" align="center">
          </el-table-column>
          <el-table-column type="index" width="40" align="center">
          </el-table-column>
          <el-table-column
            prop="isHostOperate"
            label="运营类别"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{ scope.row.isHostOperate == "01" ? "代运营" : "自运营" }} -->
              <span v-if="scope.row.isHostOperate == '01'">代运营</span>
              <span v-if="scope.row.isHostOperate == '02'">自运营</span>
              <span
                v-if="
                  scope.row.isHostOperate === '' ||
                    scope.row.isHostOperate === null
                "
                >代运营/自运营</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="dealName"
            label="运营商名称"
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="stationName"
            label="电站名称"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="!scope.row.stationAddr ? '无' : scope.row.stationAddr"
                placement="top"
              >
                <span>{{ scope.row.stationName }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="staticStartTime"
            label="开始时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.staticStartTimeYoy"
              >
              </span>
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.staticStartTimeQoq"
              ></span>
              <span v-if="scope.row.yoy == ''">{{
                scope.row.staticStartTime
              }}</span>
              <!-- {{
                scope.row.yoy == "Y"
                  ? scope.row.staticStartTimeYoy.replace('同比', '<b>&emsp;同比&emsp;</b>')
                  : scope.row.yoy == "N"
                  ? scope.row.staticStartTimeQoq.replace('环比', '&emsp;环比&emsp;')
                  : scope.row.staticStartTime
              }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="staticEndTime"
            label="结束时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.staticEndTimeYoy"
              >
              </span>
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.staticEndTimeQoq"
              ></span>
              <span v-if="scope.row.yoy == ''">{{
                scope.row.staticEndTime
              }}</span>
              <!-- {{
                scope.row.yoy == "Y"
                  ? scope.row.staticEndTimeYoy.replace('同比', '&emsp;同比&emsp;')
                  : scope.row.yoy == "N"
                  ? scope.row.staticEndTimeQoq.replace('环比', '&emsp;环比&emsp;')
                  : scope.row.staticEndTime
              }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="noOrderPileCount"
            label="无订单桩数量"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.noOrderPileCountYoy"
                @click="bindClick(scope.row, $event)"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.noOrderPileCountYoy === '' ||
                      scope.row.noOrderPileCountYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.noOrderPileCountQoq"
                @click="bindClick(scope.row, $event)"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.noOrderPileCountQoq === '' ||
                      scope.row.noOrderPileCountQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.noOrderPileCount !== ''"
                v-html="scope.row.noOrderPileCount"
                @click="bindClick(scope.row, $event)"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.noOrderPileCount === '' ||
                      scope.row.noOrderPileCount === null)
                "
                >数据处理中</span
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="orderPileCount"
            label="有订单桩数量"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.orderPileCountYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.orderPileCountYoy === '' ||
                      scope.row.orderPileCountYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.orderPileCountQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.orderPileCountQoq === '' ||
                      scope.row.orderPileCountQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.orderPileCount !== ''"
                v-html="scope.row.orderPileCount"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.orderPileCount === '' ||
                      scope.row.orderPileCount === null)
                "
                >数据处理中</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="orderPileDayAveCount"
            label="桩日均订单量"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.orderPileDayAveCountYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.orderPileDayAveCountYoy === '' ||
                      scope.row.orderPileDayAveCountYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.orderPileDayAveCountQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.orderPileDayAveCountQoq === '' ||
                      scope.row.orderPileDayAveCountQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="
                  scope.row.yoy == '' && scope.row.orderPileDayAveCount !== ''
                "
                v-html="scope.row.orderPileDayAveCount"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.orderPileDayAveCount === '' ||
                      scope.row.orderPileDayAveCount === null)
                "
                >数据处理中</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="orderChareAveCount"
            label="平均订单电量"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.orderChareAveCountYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.orderChareAveCountYoy === '' ||
                      scope.row.orderChareAveCountYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.orderChareAveCountQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.orderChareAveCountQoq === '' ||
                      scope.row.orderChareAveCountQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="
                  scope.row.yoy == '' && scope.row.orderChareAveCount !== ''
                "
                v-html="scope.row.orderChareAveCount"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.orderChareAveCount === '' ||
                      scope.row.orderChareAveCount === null)
                "
                >数据处理中</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="orderTimeAveCount"
            label="平均订单时长"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.orderTimeAveCountYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.orderTimeAveCountYoy === '' ||
                      scope.row.orderTimeAveCountYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.orderTimeAveCountQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.orderTimeAveCountQoq === '' ||
                      scope.row.orderTimeAveCountQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.orderTimeAveCount !== ''"
                v-html="scope.row.orderTimeAveCount"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.orderTimeAveCount === '' ||
                      scope.row.orderTimeAveCount === null)
                "
                >数据处理中</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="feeAveCount"
            label="平均客单价"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.feeAveCountYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.feeAveCountYoy === '' ||
                      scope.row.feeAveCountYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.feeAveCountQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.feeAveCountQoq === '' ||
                      scope.row.feeAveCountQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.feeAveCount !== ''"
                v-html="scope.row.feeAveCount"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.feeAveCount === '' ||
                      scope.row.feeAveCount === null)
                "
                >数据处理中</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="custCount"
            label="用户数"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.custCountYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.custCountYoy === '' ||
                      scope.row.custCountYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.custCountQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.custCountQoq === '' ||
                      scope.row.custCountQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.custCount !== ''"
                v-html="scope.row.custCount"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.custCount === '' || scope.row.custCount === null)
                "
                >数据处理中</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="orderCount"
            label="订单量"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.yoy == 'Y'" v-html="scope.row.orderCountYoy"></span>
              <span v-if="scope.row.yoy == 'N'" v-html="scope.row.orderCountQoq"></span>  -->
              <span
                v-if="scope.row.yoy == 'Y' && scope.row.orderCountYoy !== ''"
                v-html="scope.row.orderCountYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.orderCountYoy == '' ||
                      scope.row.orderCountYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N' && scope.row.orderCountQoq !== ''"
                v-html="scope.row.orderCountQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy === 'N' &&
                    (scope.row.orderCountQoq === '' ||
                      scope.row.orderCountQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.orderCount !== ''"
                v-html="scope.row.orderCount"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.orderCount === '' ||
                      scope.row.orderCount === null)
                "
                >数据处理中</span
              >
              <!-- {{
                scope.row.yoy == "Y"
                  ?  scope.row.orderCountYoy
                  : scope.row.yoy == "N"
                  ? scope.row.orderCountQoq
                  : scope.row.orderCount
              }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="orderUnpaidCount"
            label="未支付数量"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.orderUnpaidCountYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.orderUnpaidCountYoy === '' ||
                      scope.row.orderUnpaidCountYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.orderUnpaidCountQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.orderUnpaidCountQoq === '' ||
                      scope.row.orderUnpaidCountQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.orderUnpaidCount !== ''"
                v-html="scope.row.orderUnpaidCount"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.orderUnpaidCount === '' ||
                      scope.row.orderUnpaidCount === null)
                "
                >数据处理中</span
              >

              <!-- {{
                scope.row.yoy == "Y"
                  ? scope.row.orderUnpaidCountYoy
                  : scope.row.yoy == "N"
                  ? scope.row.orderUnpaidCountQoq
                  : scope.row.orderUnpaidCount
              }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="chargeVal"
            label="总电量(度)"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.chargeValYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.chargeValYoy === '' ||
                      scope.row.chargeValYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.chargeValQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.chargeValQoq === '' ||
                      scope.row.chargeValQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.chargeVal !== ''"
                v-html="scope.row.chargeVal"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.chargeVal === '' || scope.row.chargeVal === null)
                "
                >数据处理中</span
              >
              <!-- {{
                scope.row.yoy == "Y"
                  ? scope.row.chargeValYoy
                  : scope.row.yoy == "N"
                  ? scope.row.chargeValQoq
                  : scope.row.chargeVal
              }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="actFee"
            label="应收电费(元)"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.actFeeYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.actFeeYoy === '' || scope.row.actFeeYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.actFeeQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.actFeeQoq === '' || scope.row.actFeeQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.actFee !== ''"
                v-html="scope.row.actFee"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.actFee === '' || scope.row.actFee === null)
                "
                >数据处理中</span
              >
              <!-- {{
                scope.row.yoy == "Y"
                  ? scope.row.actFeeYoy
                  : scope.row.yoy == "N"
                  ? scope.row.actFeeQoq
                  : scope.row.actFee
              }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="actPayFee"
            label="实收电费(元)"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.actPayFeeYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.actPayFeeYoy === '' ||
                      scope.row.actPayFeeYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.actPayFeeQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.actPayFeeQoq === '' ||
                      scope.row.actPayFeeQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.actPayFee !== ''"
                v-html="scope.row.actPayFee"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.actPayFee === '' || scope.row.actPayFee === null)
                "
                >数据处理中</span
              >
              <!-- {{
                scope.row.yoy == "Y"
                  ? scope.row.actPayFeeYoy
                  : scope.row.yoy == "N"
                  ? scope.row.actPayFeeQoq
                  : scope.row.actPayFee
              }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="deductionFee"
            label="账户余额支付(元)"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.deductionFeeYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.deductionFeeYoy === '' ||
                      scope.row.deductionFeeYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.deductionFeeQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.deductionFeeQoq === '' ||
                      scope.row.deductionFeeQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.deductionFee !== ''"
                v-html="scope.row.deductionFee"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.deductionFee === '' ||
                      scope.row.deductionFee === null)
                "
                >数据处理中</span
              >
              <!-- {{
                scope.row.yoy == "Y"
                  ? scope.row.deductionFeeYoy
                  : scope.row.yoy == "N"
                  ? scope.row.deductionFeeQoq
                  : scope.row.deductionFee
              }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="deductionElec"
            label="度电支付(k-Wh)"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.yoy == 'Y'"
                v-html="scope.row.deductionElecYoy"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'Y' &&
                    (scope.row.deductionElecYoy === '' ||
                      scope.row.deductionElecYoy === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == 'N'"
                v-html="scope.row.deductionElecQoq"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == 'N' &&
                    (scope.row.deductionElecQoq === '' ||
                      scope.row.deductionElecQoq === null)
                "
                >数据处理中</span
              >
              <span
                v-if="scope.row.yoy == '' && scope.row.deductionElec !== ''"
                v-html="scope.row.deductionElec"
              ></span>
              <span
                style="color:blue;"
                v-if="
                  scope.row.yoy == '' &&
                    (scope.row.deductionElec === '' ||
                      scope.row.deductionElec === null)
                "
                >数据处理中</span
              >
            </template>
          </el-table-column>
          
          <el-table-column
            prop="lastModifiedWhen"
            label="数据统计日期"
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import util from "@/common/util.js";
import utils from "@/utils/utils.js";
export default {
  data() {
    return {
      stationNo: [],
      stationFlag: "",
      dealName: [],
      dealNo: [],
      dealerArr: [],
      siteArr: [],
      pageConfig: pageConfig, // 页面配置
      tableData: [
        {
          dealName: "5554545",
          staticId: "465",
        },
        {
          dealName: "485623",
          staticId: "78465",
        },
      ], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //标签页与 搜索框
      pageList: {},
      operates: {
        width: 150,
        fixed: "right",
        list: [],
      }, // 列操作按钮
      userInfo: {}, //用户信息
      pickerMinDate: "",
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          //如果选中结束时间,则小于所选当前时间
          if (maxDate) {
            this.pickerMinDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== "") {
            let one = 30 * 24 * 3600 * 1000;
            let minTime = this.pickerMinDate - one;
            let maxTime = this.pickerMinDate + one;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return time.getTime() > Date.now();
        },
      },
      searchTime: [], //时间
    };
  },
  methods: {
    /*
     *初始化
     *@Api:
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    // 站点模糊搜索
    // pileCodeRemoteMethod(query) {
    //   let _ = this;
    //   _.siteArr = [];
    //   _.$U.showLoading(_);
    //   if (query !== "" && query.length >= 2) {
    //     setTimeout(async () => {
    //       const res = await _.$H.post(_.$A.pileStation.listStationByDeal, {
    //         pileCode: query,
    //       });
    //       res.data.data.map((v) => {
    //         _.siteArr.push(v.stationName);
    //       });
    //       _.$U.showLoading(_);
    //     }, 200);
    //   } else {
    //     _.siteArr = [];
    //   }
    // },

    handleClick(row) {
      let _ = this;
      _.$U.showLoading(_);
      _.$H
        .post(_, _.$A.pileStation.del, { staticId: row.staticId })
        .then((res) => {
          _.getListData(this.pagination, true);
          _.$U.showLoading(_);
        });
    },
    getTableSection() {
      if (this.selections.length <= 0) {
        utils.error("请选择需要操作的记录");
        return;
      } else if (this.selections.length > 1) {
        utils.error("请选择一条记录进行操作");
        return;
      }
    },
    //获取运营商数据下拉框
    getDealer() {
      let _ = this;
      _.$H.post(_, _.$A.dealer.allList, {}).then((res) => {
        _.dealerArr = res.data.data;
      });
    },
    getSite(val) {
      let _ = this;
      let obj = {};
      obj.dealerNo = Array.from(new Set(_.dealNo)).join(",");
      obj.isHostOperate = _.queryInfo.isHostOperate;
      _.$H.post(_, _.$A.pileStation.listStationByDeal, obj).then((res) => {
        if (res.data.data.length > 0) {
          res.data.data.unshift({
            stationName: "全部电站",
            stationNo: "pt555",
          });
          _.siteArr = res.data.data || [];
          // let arr = [];
          // res.data.data.forEach((item) => {
          //   if (item.stationNo == "PT1559093103411") {
          //     arr.push(item);
          //   }
          // });
        }
      });
    },
    init() {
      // let phone = '13803820751'
      // this.p =  phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');

      this.userInfo = this.$store.state.userInfo;
      // this.siteArr = []
      this.getListData(this.pagination, true);
      this.getDealer();
      // this.getSite();
    },
    getdealerArr(val) {
      this.dealName = [];
      this.dealNo = [];
      this.siteArr = [];
      val.forEach((item) => {
        // this.dealName.push(item.dealName);
        this.dealNo.push(item.dealNo);
      });

      // this.getSite(val.dealNo);
    },
    getSiteAll() {
      if (this.queryInfo.dealName == "" || this.queryInfo.dealName == null) {
        this.siteArr = [];
        return this.$message.error("请选择运营商!");
      } else {
        this.getSite();
      }
    },
    getSiteArr(val) {
      this.stationNo = [];
      val.forEach((item, index) => {
        this.stationNo.push(item.stationNo);

        if (this.stationNo.indexOf("pt555") != -1) {
          this.stationFlag = "Y";
        } else {
          this.stationFlag = "N";
        }
      });
      if (val.length <= 0) {
        return (this.stationFlag = "");
      }
    },
    getSerech() {
      let _ = this;

      if (_.searchTime == null || _.searchTime.length == 0) {
        return _.$message.error("请选择时间区间!");
      } else if (_.stationFlag == "Y" && _.queryInfo.dealName == "") {
        return _.$message.error("请选择运营商!");
      } else {
        let obj = JSON.parse(JSON.stringify(_.queryInfo));
        obj.dtFrom += " 00:00:00";
        obj.dtTo += " 23:59:59";
        obj.dealNo = Array.from(new Set(_.dealNo)).join(",");

        if (_.stationNo.length > 1 && _.stationNo.indexOf("pt555") != -1) {
          // obj.stationName.splice(obj.stationName.indexOf("全部电站"), 1);
          _.stationNo.splice(_.stationNo.indexOf("pt555"), 1);
          _.stationFlag = "Y";
        }
        // if (
        //   _.stationNo.length <= 1 &&
        //   _.stationNo.indexOf("pt555") != -1
        // ) {

        //   // obj.stationName.splice(obj.stationName.indexOf("全部电站"), 1);
        //   _.stationNo.splice(_.stationNo.indexOf("pt555"), 1);
        //   _.stationFlag = "Y";
        // }

        obj.stationNo = Array.from(new Set(_.stationNo)).join(",");
        obj.stationName = obj.stationName.join(",");

        obj.stationFlag = _.stationFlag;
        _.$message({
          showClose: true,
          message: "数据正在计算中,请稍等!",
          type: "warning",
          offset: 80,
        });
        delete obj.dealName;
        delete obj.stationName;
        // let Arr = _.tableData
        _.$H.post(_, _.$A.pileStation.StatisFilt, obj).then((res) => {
          if (res.data.data === false) {
            return _.$message.error("当前筛选条件下暂无数据!");
          } else {
            _.searchTime = [];
            delete _.queryInfo.stationName;
            delete _.queryInfo.dtFrom;
            delete _.queryInfo.dtTo;
            delete _.queryInfo.isHostOperate;
            delete _.queryInfo.dealName;
            delete _.queryInfo.yoy;

            _.getListData(this.pagination, true);
            _.$message.success("筛选成功!");
          }

          // _.pagination.total = res.data.data.totalElements || 0;
          // _.$U.hideLoading(_);
        });
      }
    },
    /*
     *选择注册时间
     *@Api:
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    handleQoq() {
      // this.getTableSection()
      if (this.selections.length <= 0) {
        utils.error("请选择需要操作的记录");
        return;
      } else {
        let _ = this;
        _.$U.showLoading(_);
        let arr = [];
        _.selections.forEach((item) => {
          arr.push(item.staticId);
        });
        let obj = {};
        obj.staticId = arr.join(",");
        obj.yoy = "N";

        _.$H.post(_, _.$A.pileStation.StatisBatch, obj).then((res) => {
          _.queryInfo.yoy = "N";
          _.getListData(this.pagination, true);
          delete _.queryInfo.yoy;
          _.$U.hideLoading(_);
          _.$message.success("转换成功");
        });
      }
    },
    handleYoy() {
      if (this.selections.length <= 0) {
        utils.error("请选择需要操作的记录");
        return;
      } else {
        let _ = this;
        _.$U.showLoading(_);
        let arr = [];
        _.selections.forEach((item) => {
          arr.push(item.staticId);
        });
        let obj = {};
        obj.staticId = arr.join(",");
        obj.yoy = "Y";

        _.$H.post(_, _.$A.pileStation.StatisBatch, obj).then((res) => {
          _.queryInfo.yoy = "Y";
          _.getListData(this.pagination, true);
          delete _.queryInfo.yoy;
          _.$U.hideLoading(_);
          _.$message.success("转换成功");
        });
      }
    },
    handleDel() {
      if (this.selections.length <= 0) {
        utils.error("请选择需要操作的记录");
        return;
      } else {
        let _ = this;
        _.$U.showLoading(_);
        let arr = [];
        _.selections.forEach((item) => {
          arr.push(item.staticId);
        });
        let obj = {};
        obj.staticId = arr.join(",");

        _.$H.post(_, _.$A.pileStation.del, obj).then((res) => {
          _.getListData(this.pagination, true);
          _.$U.showLoading(_);
          _.$message.success("删除成功");
        });
      }
    },
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0];
        this.queryInfo.dtTo = val[1];
      } else {
        this.searchTime = [];
        this.queryInfo.dtFrom = "";
        this.queryInfo.dtTo = "";
      }
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.pageList.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.pageList.pageNum = 0;
      }
      _.pageList.pageSize = pagination.pageSize;
      let obj = JSON.parse(JSON.stringify(_.pageList));
      _.$H.post(_, _.$A.pileStation.page, obj).then((res) => {
        console.log(res.data.data.content);
        res.data.data.content.forEach((item) => {
          item.staticStartTimeQoq = item.staticStartTimeQoq.replace(
            "环比",
            `<b>&emsp;环比&emsp;</b>`
          );
          item.staticEndTimeQoq = item.staticEndTimeQoq.replace(
            "环比",
            `<b>&emsp;环比&emsp;</b>`
          );
          item.staticStartTimeYoy = item.staticStartTimeYoy.replace(
            "同比",
            `<b>&emsp;同比&emsp;</b>`
          );
          item.staticEndTimeYoy = item.staticEndTimeYoy.replace(
            "同比",
            `<b>&emsp;同比&emsp;</b>`
          );
          if(item.noOrderPileCount!=''){
            item.noOrderPileCount = item.noOrderPileCount.replace(
            item.noOrderPileCount,
                `<a style='color:blue;font-size:inherit;text-decoration: underline;'>${item.noOrderPileCount}</a>`
              );
          }
          
          if (
            item.yoy == "N" &&
            item.orderCountQoq != "" &&
            item.orderUnpaidCountQoq != "" &&
            item.chargeValQoq != "" &&
            item.actFeeQoq != "" &&
            item.actPayFeeQoq != "" &&
            item.deductionFeeQoq != "" &&
            item.deductionElecQoq != "" &&
            item.noOrderPileCountQoq != "" &&
            item.orderPileCountQoq != "" &&
            item.orderPileDayAveCountQoq != "" &&
            item.orderChareAveCountQoq != "" &&
            item.orderTimeAveCountQoq != "" &&
            item.feeAveCountQoq != "" &&
            item.custCountQoq != ""
          ) {
            // 订单量
            let ocq1 = item.orderCountQoq.substring(
              item.orderCountQoq.indexOf("+")
            );
            let ocq11 = item.orderCountQoq.substring(
              0,
              item.orderCountQoq.indexOf("+")
            );

            let ocq2 = item.orderCountQoq.substring(
              item.orderCountQoq.lastIndexOf("-", item.orderCountQoq.length - 1)
            );
            let ocq22 = item.orderCountQoq.substring(
              0,
              item.orderCountQoq.lastIndexOf("-", item.orderCountQoq.length - 1)
            );

            // let ocq2 = item.orderCountQoq.substring(
            //   item.orderCountQoq.indexOf("-")
            // );
            // let ocq22 = item.orderCountQoq.substring(
            //   0,
            //   item.orderCountQoq.indexOf("-")
            // );
            // 未支付数量
            let ucq1 = item.orderUnpaidCountQoq.substring(
              item.orderUnpaidCountQoq.indexOf("+")
            );
            let ucq11 = item.orderUnpaidCountQoq.substring(
              0,
              item.orderUnpaidCountQoq.indexOf("+")
            );

            let ucq2 = item.orderUnpaidCountQoq.substring(
              item.orderUnpaidCountQoq.lastIndexOf(
                "-",
                item.orderUnpaidCountQoq.length - 1
              )
            );
            let ucq22 = item.orderUnpaidCountQoq.substring(
              0,
              item.orderUnpaidCountQoq.lastIndexOf(
                "-",
                item.orderUnpaidCountQoq.length - 1
              )
            );

            // let ucq2 = item.orderUnpaidCountQoq.substring(
            //   item.orderUnpaidCountQoq.indexOf("-")
            // );
            // let ucq22 = item.orderUnpaidCountQoq.substring(
            //   0,
            //   item.orderUnpaidCountQoq.indexOf("-")
            // );
            // 总电量
            let caq1 = item.chargeValQoq.substring(
              item.chargeValQoq.indexOf("+")
            );
            let caq11 = item.chargeValQoq.substring(
              0,
              item.chargeValQoq.indexOf("+")
            );

            let caq2 = item.chargeValQoq.substring(
              item.chargeValQoq.lastIndexOf("-", item.chargeValQoq.length - 1)
            );
            let caq22 = item.chargeValQoq.substring(
              0,
              item.chargeValQoq.lastIndexOf("-", item.chargeValQoq.length - 1)
            );

            // let caq2 = item.chargeValQoq.substring(
            //   item.chargeValQoq.indexOf("-")
            // );
            // let caq22 = item.chargeValQoq.substring(
            //   0,
            //   item.chargeValQoq.indexOf("-")
            // );
            // 应收电费
            let afq1 = item.actFeeQoq.substring(item.actFeeQoq.indexOf("+"));
            let afq11 = item.actFeeQoq.substring(
              0,
              item.actFeeQoq.indexOf("+")
            );

            let afq2 = item.actFeeQoq.substring(
              item.actFeeQoq.lastIndexOf("-", item.actFeeQoq.length - 1)
            );
            let afq22 = item.actFeeQoq.substring(
              0,
              item.actFeeQoq.lastIndexOf("-", item.actFeeQoq.length - 1)
            );

            // let afq2 = item.actFeeQoq.substring(item.actFeeQoq.indexOf("-"));
            // let afq22 = item.actFeeQoq.substring(
            //   0,
            //   item.actFeeQoq.indexOf("-")
            // );
            // 实收电费
            let apfq1 = item.actPayFeeQoq.substring(
              item.actPayFeeQoq.indexOf("+")
            );
            let apfq11 = item.actPayFeeQoq.substring(
              0,
              item.actPayFeeQoq.indexOf("+")
            );

            let apfq2 = item.actPayFeeQoq.substring(
              item.actPayFeeQoq.lastIndexOf("-", item.actPayFeeQoq.length - 1)
            );
            let apfq22 = item.actPayFeeQoq.substring(
              0,
              item.actPayFeeQoq.lastIndexOf("-", item.actPayFeeQoq.length - 1)
            );

            // let apfq2 = item.actPayFeeQoq.substring(
            //   item.actPayFeeQoq.indexOf("-")
            // );
            // let apfq22 = item.actPayFeeQoq.substring(
            //   0,
            //   item.actPayFeeQoq.indexOf("-")
            // );
            // 账户余额支付
            let dfq1 = item.deductionFeeQoq.substring(
              item.deductionFeeQoq.indexOf("+")
            );
            let dfq11 = item.deductionFeeQoq.substring(
              0,
              item.deductionFeeQoq.indexOf("+")
            );

            let dfq2 = item.deductionFeeQoq.substring(
              item.deductionFeeQoq.lastIndexOf(
                "-",
                item.deductionFeeQoq.length - 1
              )
            );
            let dfq22 = item.deductionFeeQoq.substring(
              0,
              item.deductionFeeQoq.lastIndexOf(
                "-",
                item.deductionFeeQoq.length - 1
              )
            );

            // let dfq2 = item.deductionFeeQoq.substring(
            //   item.deductionFeeQoq.indexOf("-")
            // );
            // let dfq22 = item.deductionFeeQoq.substring(
            //   0,
            //   item.deductionFeeQoq.indexOf("-")
            // );
            // 度电支付
            let deq1 = item.deductionElecQoq.substring(
              item.deductionElecQoq.indexOf("+")
            );
            let deq11 = item.deductionElecQoq.substring(
              0,
              item.deductionElecQoq.indexOf("+")
            );

            let deq2 = item.deductionElecQoq.substring(
              item.deductionElecQoq.lastIndexOf(
                "-",
                item.deductionElecQoq.length - 1
              )
            );
            let deq22 = item.deductionElecQoq.substring(
              0,
              item.deductionElecQoq.lastIndexOf(
                "-",
                item.deductionElecQoq.length - 1
              )
            );

            // let deq2 = item.deductionElecQoq.substring(
            //   item.deductionElecQoq.indexOf("-")
            // );
            // let deq22 = item.deductionElecQoq.substring(
            //   0,
            //   item.deductionElecQoq.indexOf("-")
            // );
            // 无订单桩量
            let noq1 = item.noOrderPileCountQoq.substring(
              item.noOrderPileCountQoq.indexOf("+")
            );
            let noq11 = item.noOrderPileCountQoq.substring(
              0,
              item.noOrderPileCountQoq.indexOf("+")
            );

            let noq2 = item.noOrderPileCountQoq.substring(
              item.noOrderPileCountQoq.lastIndexOf(
                "-",
                item.noOrderPileCountQoq.length - 1
              )
            );

            let noq22 = item.noOrderPileCountQoq.substring(
              0,
              item.noOrderPileCountQoq.lastIndexOf(
                "-",
                item.noOrderPileCountQoq.length - 1
              )
            );
            // -
            // console.log(noq22);
            let noq3 = noq22.substring(0, noq22.indexOf("环"));
            let noq33 = noq22.substr(noq22.length - 1, 1);

            // +
            // console.log(noq11);
            let noq4 = noq11.substring(0, noq11.indexOf("环"));
            let noq44 = noq11.substr(noq11.length - 1, 1);
            console.log(noq4, noq44);

            // console.log(noq3,noq33);
            // let noq2 = item.noOrderPileCountQoq.substring(
            //   item.noOrderPileCountQoq.indexOf("-")
            // );
            // let noq22 = item.noOrderPileCountQoq.substring(
            //   0,
            //   item.noOrderPileCountQoq.indexOf("-")
            // );
            // 有订单桩量
            let yeq1 = item.orderPileCountQoq.substring(
              item.orderPileCountQoq.indexOf("+")
            );
            let yeq11 = item.orderPileCountQoq.substring(
              0,
              item.orderPileCountQoq.indexOf("+")
            );

            let yeq2 = item.orderPileCountQoq.substring(
              item.orderPileCountQoq.lastIndexOf(
                "-",
                item.orderPileCountQoq.length - 1
              )
            );
            let yeq22 = item.orderPileCountQoq.substring(
              0,
              item.orderPileCountQoq.lastIndexOf(
                "-",
                item.orderPileCountQoq.length - 1
              )
            );

            // let yeq2 = item.orderPileCountQoq.substring(
            //   item.orderPileCountQoq.indexOf("-")
            // );
            // let yeq22 = item.orderPileCountQoq.substring(
            //   0,
            //   item.orderPileCountQoq.indexOf("-")
            // );
            // 桩日均量
            let orq1 = item.orderPileDayAveCountQoq.substring(
              item.orderPileDayAveCountQoq.indexOf("+")
            );
            let orq11 = item.orderPileDayAveCountQoq.substring(
              0,
              item.orderPileDayAveCountQoq.indexOf("+")
            );

            let orq2 = item.orderPileDayAveCountQoq.substring(
              item.orderPileDayAveCountQoq.lastIndexOf(
                "-",
                item.orderPileDayAveCountQoq.length - 1
              )
            );
            let orq22 = item.orderPileDayAveCountQoq.substring(
              0,
              item.orderPileDayAveCountQoq.lastIndexOf(
                "-",
                item.orderPileDayAveCountQoq.length - 1
              )
            );

            // let orq2 = item.orderPileDayAveCountQoq.substring(
            //   item.orderPileDayAveCountQoq.indexOf("-")
            // );
            // let orq22 = item.orderPileDayAveCountQoq.substring(
            //   0,
            //   item.orderPileDayAveCountQoq.indexOf("-")
            // );
            // 平均量
            let chq1 = item.orderChareAveCountQoq.substring(
              item.orderChareAveCountQoq.indexOf("+")
            );
            let chq11 = item.orderChareAveCountQoq.substring(
              0,
              item.orderChareAveCountQoq.indexOf("+")
            );

            let chq2 = item.orderChareAveCountQoq.substring(
              item.orderChareAveCountQoq.lastIndexOf(
                "-",
                item.orderChareAveCountQoq.length - 1
              )
            );
            let chq22 = item.orderChareAveCountQoq.substring(
              0,
              item.orderChareAveCountQoq.lastIndexOf(
                "-",
                item.orderChareAveCountQoq.length - 1
              )
            );

            // let chq2 = item.orderChareAveCountQoq.substring(
            //   item.orderChareAveCountQoq.indexOf("-")
            // );
            // let chq22 = item.orderChareAveCountQoq.substring(
            //   0,
            //   item.orderChareAveCountQoq.indexOf("-")
            // );
            // 平均订单时长
            let tmq1 = item.orderTimeAveCountQoq.substring(
              item.orderTimeAveCountQoq.indexOf("+")
            );
            let tmq11 = item.orderTimeAveCountQoq.substring(
              0,
              item.orderTimeAveCountQoq.indexOf("+")
            );

            let tmq2 = item.orderTimeAveCountQoq.substring(
              item.orderTimeAveCountQoq.lastIndexOf(
                "-",
                item.orderTimeAveCountQoq.length - 1
              )
            );
            let tmq22 = item.orderTimeAveCountQoq.substring(
              0,
              item.orderTimeAveCountQoq.lastIndexOf(
                "-",
                item.orderTimeAveCountQoq.length - 1
              )
            );

            // let tmq2 = item.orderTimeAveCountQoq.substring(
            //   item.orderTimeAveCountQoq.indexOf("-")
            // );
            // let tmq22 = item.orderTimeAveCountQoq.substring(
            //   0,
            //   item.orderTimeAveCountQoq.indexOf("-")
            // );
            // 平均订单金额
            let feq1 = item.feeAveCountQoq.substring(
              item.feeAveCountQoq.indexOf("+")
            );
            let feq11 = item.feeAveCountQoq.substring(
              0,
              item.feeAveCountQoq.indexOf("+")
            );

            let feq2 = item.feeAveCountQoq.substring(
              item.feeAveCountQoq.lastIndexOf(
                "-",
                item.feeAveCountQoq.length - 1
              )
            );
            let feq22 = item.feeAveCountQoq.substring(
              0,
              item.feeAveCountQoq.lastIndexOf(
                "-",
                item.feeAveCountQoq.length - 1
              )
            );

            // let feq2 = item.feeAveCountQoq.substring(
            //   item.feeAveCountQoq.indexOf("-")
            // );
            // let feq22 = item.feeAveCountQoq.substring(
            //   0,
            //   item.feeAveCountQoq.indexOf("-")
            // );
            // 用户量
            let cuq1 = item.custCountQoq.substring(
              item.custCountQoq.indexOf("+")
            );
            let cuq11 = item.custCountQoq.substring(
              0,
              item.custCountQoq.indexOf("+")
            );

            let cuq2 = item.custCountQoq.substring(
              item.custCountQoq.lastIndexOf("-", item.custCountQoq.length - 1)
            );
            let cuq22 = item.custCountQoq.substring(
              0,
              item.custCountQoq.lastIndexOf("-", item.custCountQoq.length - 1)
            );

            // let cuq2 = item.custCountQoq.substring(
            //   item.custCountQoq.indexOf("-")
            // );
            // let cuq22 = item.custCountQoq.substring(
            //   0,
            //   item.custCountQoq.indexOf("-")
            // );

            // 订单量

            item.orderCountQoq = item.orderCountQoq.replace(
              ocq1,
              `<br/><span style='color:red;'>${ocq1}</span>`
            );
            item.orderCountQoq = item.orderCountQoq.replace(
              ocq11,
              `<span style='color:black;'>${ocq11}</span>`
            );
            item.orderCountQoq = item.orderCountQoq.replace(
              ocq2,
              `<br/><span style='color:green;'>${ocq2}</span>`
            );
            item.orderCountQoq = item.orderCountQoq.replace(
              ocq22,
              `<span style='color:black;'>${ocq22}</span>`
            );
            item.orderCountQoq = item.orderCountQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // item.staticStartTimeYoy = item.staticStartTimeYoy.replace('环比',`<b>&emsp;环比&emsp;</b>`)

            // 未支付数量
            item.orderUnpaidCountQoq = item.orderUnpaidCountQoq.replace(
              ucq1,
              `<br/><span style='color:red;'>${ucq1}</span>`
            );
            item.orderUnpaidCountQoq = item.orderUnpaidCountQoq.replace(
              ucq11,
              `<span style='color:black;'>${ucq11}</span>`
            );
            item.orderUnpaidCountQoq = item.orderUnpaidCountQoq.replace(
              ucq2,
              `<br/><span style='color:green;'>${ucq2}</span>`
            );
            item.orderUnpaidCountQoq = item.orderUnpaidCountQoq.replace(
              ucq22,
              `<span style='color:black;'>${ucq22}</span>`
            );
            item.orderUnpaidCountQoq = item.orderUnpaidCountQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 总电量
            item.chargeValQoq = item.chargeValQoq.replace(
              caq1,
              `<br/><span style='color:red;'>${caq1}</span>`
            );
            item.chargeValQoq = item.chargeValQoq.replace(
              caq11,
              `<span style='color:black;'>${caq11}</span>`
            );
            item.chargeValQoq = item.chargeValQoq.replace(
              caq2,
              `<br/><span style='color:green;'>${caq2}</span>`
            );
            item.chargeValQoq = item.chargeValQoq.replace(
              caq22,
              `<span style='color:black;'>${caq22}</span>`
            );
            item.chargeValQoq = item.chargeValQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 应收电费
            item.actFeeQoq = item.actFeeQoq.replace(
              afq1,
              `<br/><span style='color:red;'>${afq1}</span>`
            );
            item.actFeeQoq = item.actFeeQoq.replace(
              afq11,
              `<span style='color:black;'>${afq11}</span>`
            );
            item.actFeeQoq = item.actFeeQoq.replace(
              afq2,
              `<br/><span style='color:green;'>${afq2}</span>`
            );
            item.actFeeQoq = item.actFeeQoq.replace(
              afq22,
              `<span style='color:black;'>${afq22}</span>`
            );
            item.actFeeQoq = item.actFeeQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 实收电费
            item.actPayFeeQoq = item.actPayFeeQoq.replace(
              apfq1,
              `<br/><span style='color:red;'>${apfq1}</span>`
            );
            item.actPayFeeQoq = item.actPayFeeQoq.replace(
              apfq11,
              `<span style='color:black;'>${apfq11}</span>`
            );
            item.actPayFeeQoq = item.actPayFeeQoq.replace(
              apfq2,
              `<br/><span style='color:green;'>${apfq2}</span>`
            );
            item.actPayFeeQoq = item.actPayFeeQoq.replace(
              apfq22,
              `<span style='color:black;'>${apfq22}</span>`
            );
            item.actPayFeeQoq = item.actPayFeeQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 账户余额支付
            item.deductionFeeQoq = item.deductionFeeQoq.replace(
              dfq1,
              `<br/><span style='color:red;'>${dfq1}</span>`
            );
            item.deductionFeeQoq = item.deductionFeeQoq.replace(
              dfq11,
              `<span style='color:black;'>${dfq11}</span>`
            );
            item.deductionFeeQoq = item.deductionFeeQoq.replace(
              dfq2,
              `<br/><span style='color:green;'>${dfq2}</span>`
            );
            item.deductionFeeQoq = item.deductionFeeQoq.replace(
              dfq22,
              `<span style='color:black;'>${dfq22}</span>`
            );
            item.deductionFeeQoq = item.deductionFeeQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 度电支付
            item.deductionElecQoq = item.deductionElecQoq.replace(
              deq1,
              `<br/><span style='color:red;'>${deq1}</span>`
            );
            item.deductionElecQoq = item.deductionElecQoq.replace(
              deq11,
              `<span style='color:black;'>${deq11}</span>`
            );
            item.deductionElecQoq = item.deductionElecQoq.replace(
              deq2,
              `<br/><span style='color:green;'>${deq2}</span>`
            );
            item.deductionElecQoq = item.deductionElecQoq.replace(
              deq22,
              `<span style='color:black;'>${deq22}</span>`
            );
            item.deductionElecQoq = item.deductionElecQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 无订单桩数量

            if (noq4!=''&&noq44 != ''&&noq4 == noq44) {
              console.log(noq4, noq44);
              // console.log(1)
              let noqReg = new RegExp("(" + noq44 + ")", "g");
              item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
                noqReg,
                `<u style='color:blue;cursor:pointer;'>$1</u>`
              );
              let noqReg2 = new RegExp("(" + noq4 + ")");
              item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
                noqReg2,
                `<a style='color:blue;font-size:inherit;text-decoration: underline;'>$1</a>`
              );
            }
            if(noq4!=''&&noq44 != ''&&noq4 != noq44) {
             
              item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
                noq4,
                `<a style='color:blue;font-size:inherit;text-decoration: underline;'>${noq4}</a>`
              );
              item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
                noq44,
                `<u style='color:blue;cursor:pointer;'>${noq44}</u>`
              );
            }

            item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
              noq1,
              `<br/><span style='color:red;'>${noq1}</span>`
            );
            item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
              noq11,
              `<span style='color:black;'>${noq11}</span>`
            );
            item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
              noq2,
              `<br/><span style='color:green;'>${noq2}</span>`
            );
            item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
              noq22,
              `<span style='color:black;'>${noq22}</span>`
            );
            item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );

            item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
              noq3,
              `<a style='color:blue;font-size:inherit;text-decoration: underline;'>${noq3}</a>`
            );
            item.noOrderPileCountQoq = item.noOrderPileCountQoq.replace(
              noq33,
              `<u style='color:blue;cursor:pointer;'>${noq33}</u>`
            );

            // 有订单桩数量
            item.orderPileCountQoq = item.orderPileCountQoq.replace(
              yeq1,
              `<br/><span style='color:red;'>${yeq1}</span>`
            );
            item.orderPileCountQoq = item.orderPileCountQoq.replace(
              yeq11,
              `<span style='color:black;'>${yeq11}</span>`
            );
            item.orderPileCountQoq = item.orderPileCountQoq.replace(
              yeq2,
              `<br/><span style='color:green;'>${yeq2}</span>`
            );
            item.orderPileCountQoq = item.orderPileCountQoq.replace(
              yeq22,
              `<span style='color:black;'>${yeq22}</span>`
            );
            item.orderPileCountQoq = item.orderPileCountQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 桩日均数量
            item.orderPileDayAveCountQoq = item.orderPileDayAveCountQoq.replace(
              orq1,
              `<br/><span style='color:red;'>${orq1}</span>`
            );
            item.orderPileDayAveCountQoq = item.orderPileDayAveCountQoq.replace(
              orq11,
              `<span style='color:black;'>${orq11}</span>`
            );
            item.orderPileDayAveCountQoq = item.orderPileDayAveCountQoq.replace(
              orq2,
              `<br/><span style='color:green;'>${orq2}</span>`
            );
            item.orderPileDayAveCountQoq = item.orderPileDayAveCountQoq.replace(
              orq22,
              `<span style='color:black;'>${orq22}</span>`
            );
            item.orderPileDayAveCountQoq = item.orderPileDayAveCountQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 平均充电量
            item.orderChareAveCountQoq = item.orderChareAveCountQoq.replace(
              chq1,
              `<br/><span style='color:red;'>${chq1}</span>`
            );
            item.orderChareAveCountQoq = item.orderChareAveCountQoq.replace(
              chq11,
              `<span style='color:black;'>${chq11}</span>`
            );
            item.orderChareAveCountQoq = item.orderChareAveCountQoq.replace(
              chq2,
              `<br/><span style='color:green;'>${chq2}</span>`
            );
            item.orderChareAveCountQoq = item.orderChareAveCountQoq.replace(
              chq22,
              `<span style='color:black;'>${chq22}</span>`
            );
            item.orderChareAveCountQoq = item.orderChareAveCountQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            //平均订单时长
            item.orderTimeAveCountQoq = item.orderTimeAveCountQoq.replace(
              tmq1,
              `<br/><span style='color:red;'>${tmq1}</span>`
            );
            item.orderTimeAveCountQoq = item.orderTimeAveCountQoq.replace(
              tmq11,
              `<span style='color:black;'>${tmq11}</span>`
            );
            item.orderTimeAveCountQoq = item.orderTimeAveCountQoq.replace(
              tmq2,
              `<br/><span style='color:green;'>${tmq2}</span>`
            );
            item.orderTimeAveCountQoq = item.orderTimeAveCountQoq.replace(
              tmq22,
              `<span style='color:black;'>${tmq22}</span>`
            );
            item.orderTimeAveCountQoq = item.orderTimeAveCountQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 平均订单金额
            item.feeAveCountQoq = item.feeAveCountQoq.replace(
              feq1,
              `<br/><span style='color:red;'>${feq1}</span>`
            );
            item.feeAveCountQoq = item.feeAveCountQoq.replace(
              feq11,
              `<span style='color:black;'>${feq11}</span>`
            );
            item.feeAveCountQoq = item.feeAveCountQoq.replace(
              feq2,
              `<br/><span style='color:green;'>${feq2}</span>`
            );
            item.feeAveCountQoq = item.feeAveCountQoq.replace(
              feq22,
              `<span style='color:black;'>${feq22}</span>`
            );
            item.feeAveCountQoq = item.feeAveCountQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
            // 用户量
            item.custCountQoq = item.custCountQoq.replace(
              cuq1,
              `<br/><span style='color:red;'>${cuq1}</span>`
            );
            item.custCountQoq = item.custCountQoq.replace(
              cuq11,
              `<span style='color:black;'>${cuq11}</span>`
            );
            item.custCountQoq = item.custCountQoq.replace(
              cuq2,
              `<br/><span style='color:green;'>${cuq2}</span>`
            );
            item.custCountQoq = item.custCountQoq.replace(
              cuq22,
              `<span style='color:black;'>${cuq22}</span>`
            );
            item.custCountQoq = item.custCountQoq.replace(
              "环比",
              `<b>&emsp;环比&emsp;</b>`
            );
          }
          if (
            item.yoy == "Y" &&
            item.orderCountYoy != "" &&
            item.orderUnpaidCountYoy != "" &&
            item.chargeValYoy != "" &&
            item.actFeeYoy != "" &&
            item.actPayFeeYoy != "" &&
            item.deductionFeeYoy != "" &&
            item.deductionElecYoy != "" &&
            item.noOrderPileCountyoy != "" &&
            item.orderPileCountyoy != "" &&
            item.orderPileDayAveCountyoy != "" &&
            item.orderChareAveCountyoy != "" &&
            item.orderTimeAveCountyoy != "" &&
            item.feeAveCountyoy != "" &&
            item.custCountyoy != ""
          ) {
            // 订单量
            let ocy1 = item.orderCountYoy.substring(
              item.orderCountYoy.indexOf("+")
            );
            let ocy11 = item.orderCountYoy.substring(
              0,
              item.orderCountYoy.indexOf("+")
            );

            let ocy2 = item.orderCountYoy.substring(
              item.orderCountYoy.lastIndexOf("-", item.orderCountYoy.length - 1)
            );
            let ocy22 = item.orderCountYoy.substring(
              0,
              item.orderCountYoy.lastIndexOf("-", item.orderCountYoy.length - 1)
            );

            // let ocy2 = item.orderCountYoy.substring(
            //   item.orderCountYoy.indexOf("-")
            // );
            // let ocy22 = item.orderCountYoy.substring(
            //   0,
            //   item.orderCountYoy.indexOf("-")
            // );
            // 未支付数量
            let ucy1 = item.orderUnpaidCountYoy.substring(
              item.orderUnpaidCountYoy.indexOf("+")
            );
            let ucy11 = item.orderUnpaidCountYoy.substring(
              0,
              item.orderUnpaidCountYoy.indexOf("+")
            );

            let ucy2 = item.orderUnpaidCountYoy.substring(
              item.orderUnpaidCountYoy.lastIndexOf(
                "-",
                item.orderUnpaidCountYoy.length - 1
              )
            );
            let ucy22 = item.orderUnpaidCountYoy.substring(
              0,
              item.orderUnpaidCountYoy.lastIndexOf(
                "-",
                item.orderUnpaidCountYoy.length - 1
              )
            );

            // let ucy2 = item.orderUnpaidCountYoy.substring(
            //   item.orderUnpaidCountYoy.indexOf("-")
            // );
            // let ucy22 = item.orderUnpaidCountYoy.substring(
            //   0,
            //   item.orderUnpaidCountYoy.indexOf("-")
            // );
            // 总电量
            let cay1 = item.chargeValYoy.substring(
              item.chargeValYoy.indexOf("+")
            );
            let cay11 = item.chargeValYoy.substring(
              0,
              item.chargeValYoy.indexOf("+")
            );

            let cay2 = item.chargeValYoy.substring(
              item.chargeValYoy.lastIndexOf("-", item.chargeValYoy.length - 1)
            );
            let cay22 = item.chargeValYoy.substring(
              0,
              item.chargeValYoy.lastIndexOf("-", item.chargeValYoy.length - 1)
            );

            // let cay2 = item.chargeValYoy.substring(
            //   item.chargeValYoy.indexOf("-")
            // );
            // let cay22 = item.chargeValYoy.substring(
            //   0,
            //   item.chargeValYoy.indexOf("-")
            // );
            // 应收电费
            let afy1 = item.actFeeYoy.substring(item.actFeeYoy.indexOf("+"));
            let afy11 = item.actFeeYoy.substring(
              0,
              item.actFeeYoy.indexOf("+")
            );

            let afy2 = item.actFeeYoy.substring(
              item.actFeeYoy.lastIndexOf("-", item.actFeeYoy.length - 1)
            );
            let afy22 = item.actFeeYoy.substring(
              0,
              item.actFeeYoy.lastIndexOf("-", item.actFeeYoy.length - 1)
            );

            // let afy2 = item.actFeeYoy.substring(item.actFeeYoy.indexOf("-"));
            // let afy22 = item.actFeeYoy.substring(
            //   0,
            //   item.actFeeYoy.indexOf("-")
            // );
            // 实收电费
            let apfy1 = item.actPayFeeYoy.substring(
              item.actPayFeeYoy.indexOf("+")
            );
            let apfy11 = item.actPayFeeYoy.substring(
              0,
              item.actPayFeeYoy.indexOf("+")
            );

            let apfy2 = item.actPayFeeYoy.substring(
              item.actPayFeeYoy.lastIndexOf("-", item.actPayFeeYoy.length - 1)
            );
            let apfy22 = item.actPayFeeYoy.substring(
              0,
              item.actPayFeeYoy.lastIndexOf("-", item.actPayFeeYoy.length - 1)
            );

            // let apfy2 = item.actPayFeeYoy.substring(
            //   item.actPayFeeYoy.indexOf("-")
            // );
            // let apfy22 = item.actPayFeeYoy.substring(
            //   0,
            //   item.actPayFeeYoy.indexOf("-")
            // );
            // 账户余额支付
            let dfy1 = item.deductionFeeYoy.substring(
              item.deductionFeeYoy.indexOf("+")
            );
            let dfy11 = item.deductionFeeYoy.substring(
              0,
              item.deductionFeeYoy.indexOf("+")
            );

            let dfy2 = item.deductionFeeYoy.substring(
              item.deductionFeeYoy.lastIndexOf(
                "-",
                item.deductionFeeYoy.length - 1
              )
            );
            let dfy22 = item.deductionFeeYoy.substring(
              0,
              item.deductionFeeYoy.lastIndexOf(
                "-",
                item.deductionFeeYoy.length - 1
              )
            );

            // let dfy2 = item.deductionFeeYoy.substring(
            //   item.deductionFeeYoy.indexOf("-")
            // );
            // let dfy22 = item.deductionFeeYoy.substring(
            //   0,
            //   item.deductionFeeYoy.indexOf("-")
            // );
            // 度电支付
            let dey1 = item.deductionElecYoy.substring(
              item.deductionElecYoy.indexOf("+")
            );
            let dey11 = item.deductionElecYoy.substring(
              0,
              item.deductionElecYoy.indexOf("+")
            );

            let dey2 = item.deductionElecYoy.substring(
              item.deductionElecYoy.lastIndexOf(
                "-",
                item.deductionElecYoy.length - 1
              )
            );
            let dey22 = item.deductionElecYoy.substring(
              0,
              item.deductionElecYoy.lastIndexOf(
                "-",
                item.deductionElecYoy.length - 1
              )
            );

            // let dey2 = item.deductionElecYoy.substring(
            //   item.deductionElecYoy.indexOf("-")
            // );
            // let dey22 = item.deductionElecYoy.substring(
            //   0,
            //   item.deductionElecYoy.indexOf("-")
            // );
            // 无订单桩数量
            let noy1 = item.noOrderPileCountYoy.substring(
              item.noOrderPileCountYoy.indexOf("+")
            );
            let noy11 = item.noOrderPileCountYoy.substring(
              0,
              item.noOrderPileCountYoy.indexOf("+")
            );

            let noy2 = item.noOrderPileCountYoy.substring(
              item.noOrderPileCountYoy.lastIndexOf(
                "-",
                item.noOrderPileCountYoy.length - 1
              )
            );
            let noy22 = item.noOrderPileCountYoy.substring(
              0,
              item.noOrderPileCountYoy.lastIndexOf(
                "-",
                item.noOrderPileCountYoy.length - 1
              )
            );
            // -
            let noy3 = noy22.substring(0, noy22.indexOf("同"));
            // console.log(noy22);
            let noy33 = noy22.substr(noy22.length - 1, 1);
            // +
            console.log(noy11);
            let noy4 = noy11.substring(0, noy11.indexOf("同"));
            // console.log(noy4);
            let noy44 = noy11.substr(noy11.length - 1, 1);
            console.log(noy4, noy44);

            // let noy2 = item.noOrderPileCountYoy.substring(
            //   item.noOrderPileCountYoy.indexOf("-")
            // );
            // let noy22 = item.noOrderPileCountYoy.substring(
            //   0,
            //   item.noOrderPileCountYoy.indexOf("-")
            // );

            // 有订单桩量
            let yey1 = item.orderPileCountYoy.substring(
              item.orderPileCountYoy.indexOf("+")
            );
            let yey11 = item.orderPileCountYoy.substring(
              0,
              item.orderPileCountYoy.indexOf("+")
            );

            let yey2 = item.orderPileCountYoy.substring(
              item.orderPileCountYoy.lastIndexOf(
                "-",
                item.orderPileCountYoy.length - 1
              )
            );
            let yey22 = item.orderPileCountYoy.substring(
              0,
              item.orderPileCountYoy.lastIndexOf(
                "-",
                item.orderPileCountYoy.length - 1
              )
            );

            // let yey2 = item.orderPileCountYoy.substring(
            //   item.orderPileCountYoy.indexOf("-")
            // );
            // let yey22 = item.orderPileCountYoy.substring(
            //   0,
            //   item.orderPileCountYoy.indexOf("-")
            // );
            // 桩日均量
            let ory1 = item.orderPileDayAveCountYoy.substring(
              item.orderPileDayAveCountYoy.indexOf("+")
            );
            let ory11 = item.orderPileDayAveCountYoy.substring(
              0,
              item.orderPileDayAveCountYoy.indexOf("+")
            );

            let ory2 = item.orderPileDayAveCountYoy.substring(
              item.orderPileDayAveCountYoy.lastIndexOf(
                "-",
                item.orderPileDayAveCountYoy.length - 1
              )
            );
            let ory22 = item.orderPileDayAveCountYoy.substring(
              0,
              item.orderPileDayAveCountYoy.lastIndexOf(
                "-",
                item.orderPileDayAveCountYoy.length - 1
              )
            );

            // let ory2 = item.orderPileDayAveCountYoy.substring(
            //   item.orderPileDayAveCountYoy.indexOf("-")
            // );
            // let ory22 = item.orderPileDayAveCountYoy.substring(
            //   0,
            //   item.orderPileDayAveCountYoy.indexOf("-")
            // );
            // 平均量
            let chy1 = item.orderChareAveCountYoy.substring(
              item.orderChareAveCountYoy.indexOf("+")
            );
            let chy11 = item.orderChareAveCountYoy.substring(
              0,
              item.orderChareAveCountYoy.indexOf("+")
            );

            let chy2 = item.orderChareAveCountYoy.substring(
              item.orderChareAveCountYoy.lastIndexOf(
                "-",
                item.orderChareAveCountYoy.length - 1
              )
            );
            let chy22 = item.orderChareAveCountYoy.substring(
              0,
              item.orderChareAveCountYoy.lastIndexOf(
                "-",
                item.orderChareAveCountYoy.length - 1
              )
            );

            // let chy2 = item.orderChareAveCountYoy.substring(
            //   item.orderChareAveCountYoy.indexOf("-")
            // );
            // let chy22 = item.orderChareAveCountYoy.substring(
            //   0,
            //   item.orderChareAveCountYoy.indexOf("-")
            // );
            // 平均订单时长
            let tmy1 = item.orderTimeAveCountYoy.substring(
              item.orderTimeAveCountYoy.indexOf("+")
            );
            let tmy11 = item.orderTimeAveCountYoy.substring(
              0,
              item.orderTimeAveCountYoy.indexOf("+")
            );
            // let tmy3 = item.orderTimeAveCountYoy.lastIndexOf('-',item.orderTimeAveCountYoy.length-1)
            // console.log(tmy3);

            let tmy2 = item.orderTimeAveCountYoy.substring(
              item.orderTimeAveCountYoy.lastIndexOf(
                "-",
                item.orderTimeAveCountYoy.length - 1
              )
            );
            let tmy22 = item.orderTimeAveCountYoy.substring(
              0,
              item.orderTimeAveCountYoy.lastIndexOf(
                "-",
                item.orderTimeAveCountYoy.length - 1
              )
            );

            // let tmy2 = item.orderTimeAveCountYoy.substring(
            //   item.orderTimeAveCountYoy.indexOf("-")
            // );
            // let tmy22 = item.orderTimeAveCountYoy.substring(
            //   0,
            //   item.orderTimeAveCountYoy.indexOf("-")
            // );
            // 平均订单金额
            let fey1 = item.feeAveCountYoy.substring(
              item.feeAveCountYoy.indexOf("+")
            );
            let fey11 = item.feeAveCountYoy.substring(
              0,
              item.feeAveCountYoy.indexOf("+")
            );

            let fey2 = item.feeAveCountYoy.substring(
              item.feeAveCountYoy.lastIndexOf(
                "-",
                item.feeAveCountYoy.length - 1
              )
            );
            let fey22 = item.feeAveCountYoy.substring(
              0,
              item.feeAveCountYoy.lastIndexOf(
                "-",
                item.feeAveCountYoy.length - 1
              )
            );

            // let fey2 = item.feeAveCountYoy.substring(
            //   item.feeAveCountYoy.indexOf("-")
            // );
            // let fey22 = item.feeAveCountYoy.substring(
            //   0,
            //   item.feeAveCountYoy.indexOf("-")
            // );
            // 用户量
            let cuy1 = item.custCountYoy.substring(
              item.custCountYoy.indexOf("+")
            );
            let cuy11 = item.custCountYoy.substring(
              0,
              item.custCountYoy.indexOf("+")
            );

            let cuy2 = item.custCountYoy.substring(
              item.custCountYoy.lastIndexOf("-", item.custCountYoy.length - 1)
            );
            let cuy22 = item.custCountYoy.substring(
              0,
              item.custCountYoy.lastIndexOf("-", item.custCountYoy.length - 1)
            );

            // let cuy2 = item.custCountYoy.substring(
            //   item.custCountYoy.indexOf("-")
            // );
            // let cuy22 = item.custCountYoy.substring(
            //   0,
            //   item.custCountYoy.indexOf("-")
            // );

            // 订单量
            item.orderCountYoy = item.orderCountYoy.replace(
              ocy1,
              `<br/><span style='color:red;'>${ocy1}</span>`
            );
            item.orderCountYoy = item.orderCountYoy.replace(
              ocy11,
              `<span style='color:black;'>${ocy11}</span>`
            );
            item.orderCountYoy = item.orderCountYoy.replace(
              ocy2,
              `<br/><span style='color:green;'>${ocy2}</span>`
            );
            item.orderCountYoy = item.orderCountYoy.replace(
              ocy22,
              `<span style='color:black;'>${ocy22}</span>`
            );
            item.orderCountYoy = item.orderCountYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 未支付数量
            item.orderUnpaidCountYoy = item.orderUnpaidCountYoy.replace(
              ucy1,
              `<br/><span style='color:red;'>${ucy1}</span>`
            );
            item.orderUnpaidCountYoy = item.orderUnpaidCountYoy.replace(
              ucy11,
              `<span style='color:black;'>${ucy11}</span>`
            );
            item.orderUnpaidCountYoy = item.orderUnpaidCountYoy.replace(
              ucy2,
              `<br/><span style='color:green;'>${ucy2}</span>`
            );
            item.orderUnpaidCountYoy = item.orderUnpaidCountYoy.replace(
              ucy22,
              `<span style='color:black;'>${ucy22}</span>`
            );
            item.orderUnpaidCountYoy = item.orderUnpaidCountYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 总电量
            item.chargeValYoy = item.chargeValYoy.replace(
              cay1,
              `<br/><span style='color:red;'>${cay1}</span>`
            );
            item.chargeValYoy = item.chargeValYoy.replace(
              cay11,
              `<span style='color:black;'>${cay11}</span>`
            );
            item.chargeValYoy = item.chargeValYoy.replace(
              cay2,
              `<br/><span style='color:green;'>${cay2}</span>`
            );
            item.chargeValYoy = item.chargeValYoy.replace(
              cay22,
              `<span style='color:black;'>${cay22}</span>`
            );
            item.chargeValYoy = item.chargeValYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 应收电费
            item.actFeeYoy = item.actFeeYoy.replace(
              afy1,
              `<br/><span style='color:red;'>${afy1}</span>`
            );
            item.actFeeYoy = item.actFeeYoy.replace(
              afy11,
              `<span style='color:black;'>${afy11}</span>`
            );
            item.actFeeYoy = item.actFeeYoy.replace(
              afy2,
              `<br/><span style='color:green;'>${afy2}</span>`
            );
            item.actFeeYoy = item.actFeeYoy.replace(
              afy22,
              `<span style='color:black;'>${afy22}</span>`
            );
            item.actFeeYoy = item.actFeeYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 实收电费
            item.actPayFeeYoy = item.actPayFeeYoy.replace(
              apfy1,
              `<br/><span style='color:red;'>${apfy1}</span>`
            );
            item.actPayFeeYoy = item.actPayFeeYoy.replace(
              apfy11,
              `<span style='color:black;'>${apfy11}</span>`
            );
            item.actPayFeeYoy = item.actPayFeeYoy.replace(
              apfy2,
              `<br/><span style='color:green;'>${apfy2}</span>`
            );
            item.actPayFeeYoy = item.actPayFeeYoy.replace(
              apfy22,
              `<span style='color:black;'>${apfy22}</span>`
            );
            item.actPayFeeYoy = item.actPayFeeYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 账户余额支付
            item.deductionFeeYoy = item.deductionFeeYoy.replace(
              dfy1,
              `<br/><span style='color:red;'>${dfy1}</span>`
            );
            item.deductionFeeYoy = item.deductionFeeYoy.replace(
              dfy11,
              `<span style='color:black;'>${dfy11}</span>`
            );
            item.deductionFeeYoy = item.deductionFeeYoy.replace(
              dfy2,
              `<br/><span style='color:green;'>${dfy2}</span>`
            );
            item.deductionFeeYoy = item.deductionFeeYoy.replace(
              dfy22,
              `<span style='color:black;'>${dfy22}</span>`
            );
            item.deductionFeeYoy = item.deductionFeeYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 度电支付
            item.deductionElecYoy = item.deductionElecYoy.replace(
              dey1,
              `<br/><span style='color:red;'>${dey1}</span>`
            );
            item.deductionElecYoy = item.deductionElecYoy.replace(
              dey11,
              `<span style='color:black;'>${dey11}</span>`
            );
            item.deductionElecYoy = item.deductionElecYoy.replace(
              dey2,
              `<br/><span style='color:green;'>${dey2}</span>`
            );
            item.deductionElecYoy = item.deductionElecYoy.replace(
              dey22,
              `<span style='color:black;'>${dey22}</span>`
            );
            item.deductionElecYoy = item.deductionElecYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 无订单桩数量
            if (noy4!=''&&noy44!=''&&noy4 == noy44) {
              let noyReg = new RegExp("(" + noy44 + ")", "g");
              item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
                noyReg,
                `<u style='color:blue;cursor:pointer;'>$1</u>`
              );
              let noyReg2 = new RegExp("(" + noy4 + ")");
              item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
                noyReg2,
                `<a style='color:blue;font-size:inherit;text-decoration: underline;'>$1</a>`
              );
            }
            if(noy4!=''&&noy44!=''&&noy4 != noy44) {
              // +
              item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
                noy4,
                `<a style='color:blue;font-size:inherit;text-decoration: underline;'>${noy4}</a>`
              );
              item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
                noy44,
                `<u style='color:blue;cursor:pointer;'>${noy44}</u>`
              );
            }
            item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
              noy1,
              `<br/><span style='color:red;'>${noy1}</span>`
            );
            item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
              noy11,
              `<span style='color:black;'>${noy11}</span>`
            );
            item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
              noy2,
              `<br/><span style='color:green;'>${noy2}</span>`
            );
            item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
              noy22,
              `<span style='color:black;'>${noy22}</span>`
            );
            item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // -
            item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
              noy3,
              `<a style='color:blue;font-size:inherit;text-decoration: underline;'>${noy3}</a>`
            );
            item.noOrderPileCountYoy = item.noOrderPileCountYoy.replace(
              noy33,
              `<u style='color:blue;cursor:pointer;'>${noy33}</u>`
            );

            // 有订单桩数量
            item.orderPileCountYoy = item.orderPileCountYoy.replace(
              yey1,
              `<br/><span style='color:red;'>${yey1}</span>`
            );
            item.orderPileCountYoy = item.orderPileCountYoy.replace(
              yey11,
              `<span style='color:black;'>${yey11}</span>`
            );
            item.orderPileCountYoy = item.orderPileCountYoy.replace(
              yey2,
              `<br/><span style='color:green;'>${yey2}</span>`
            );
            item.orderPileCountYoy = item.orderPileCountYoy.replace(
              yey22,
              `<span style='color:black;'>${yey22}</span>`
            );
            item.orderPileCountYoy = item.orderPileCountYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 桩日均数量
            item.orderPileDayAveCountYoy = item.orderPileDayAveCountYoy.replace(
              ory1,
              `<br/><span style='color:red;'>${ory1}</span>`
            );
            item.orderPileDayAveCountYoy = item.orderPileDayAveCountYoy.replace(
              ory11,
              `<span style='color:black;'>${ory11}</span>`
            );
            item.orderPileDayAveCountYoy = item.orderPileDayAveCountYoy.replace(
              ory2,
              `<br/><span style='color:green;'>${ory2}</span>`
            );
            item.orderPileDayAveCountYoy = item.orderPileDayAveCountYoy.replace(
              ory22,
              `<span style='color:black;'>${ory22}</span>`
            );
            item.orderPileDayAveCountYoy = item.orderPileDayAveCountYoy.replace(
              "同比",
              `<b >&emsp;同比&emsp;</b>`
            );
            // 平均充电量
            item.orderChareAveCountYoy = item.orderChareAveCountYoy.replace(
              chy1,
              `<br/><span style='color:red;'>${chy1}</span>`
            );
            item.orderChareAveCountYoy = item.orderChareAveCountYoy.replace(
              chy11,
              `<span style='color:black;'>${chy11}</span>`
            );
            item.orderChareAveCountYoy = item.orderChareAveCountYoy.replace(
              chy2,
              `<br/><span style='color:green;'>${chy2}</span>`
            );
            item.orderChareAveCountYoy = item.orderChareAveCountYoy.replace(
              chy22,
              `<span style='color:black;'>${chy22}</span>`
            );
            item.orderChareAveCountYoy = item.orderChareAveCountYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            //平均订单时长
            item.orderTimeAveCountYoy = item.orderTimeAveCountYoy.replace(
              tmy11,
              `<span style='color:black;'>${tmy11}</span>`
            );
            item.orderTimeAveCountYoy = item.orderTimeAveCountYoy.replace(
              tmy1,
              `<br/><span style='color:red;'>${tmy1}</span>`
            );
            item.orderTimeAveCountYoy = item.orderTimeAveCountYoy.replace(
              tmy22,
              `<span style='color:black;'>${tmy22}</span>`
            );
            item.orderTimeAveCountYoy = item.orderTimeAveCountYoy.replace(
              tmy2,
              `<br/><span style='color:green;'>${tmy2}</span>`
            );

            item.orderTimeAveCountYoy = item.orderTimeAveCountYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 平均订单金额
            item.feeAveCountYoy = item.feeAveCountYoy.replace(
              fey1,
              `<br/><span style='color:red;'>${fey1}</span>`
            );
            item.feeAveCountYoy = item.feeAveCountYoy.replace(
              fey11,
              `<span style='color:black;'>${fey11}</span>`
            );
            item.feeAveCountYoy = item.feeAveCountYoy.replace(
              fey2,
              `<br/><span style='color:green;'>${fey2}</span>`
            );
            item.feeAveCountYoy = item.feeAveCountYoy.replace(
              fey22,
              `<span style='color:black;'>${fey22}</span>`
            );
            item.feeAveCountYoy = item.feeAveCountYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
            // 用户量
            item.custCountYoy = item.custCountYoy.replace(
              cuy1,
              `<br/><span style='color:red;'>${cuy1}</span>`
            );
            item.custCountYoy = item.custCountYoy.replace(
              cuy11,
              `<span style='color:black;'>${cuy11}</span>`
            );
            item.custCountYoy = item.custCountYoy.replace(
              cuy2,
              `<br/><span style='color:green;'>${cuy2}</span>`
            );
            item.custCountYoy = item.custCountYoy.replace(
              cuy22,
              `<span style='color:black;'>${cuy22}</span>`
            );
            item.custCountYoy = item.custCountYoy.replace(
              "同比",
              `<b>&emsp;同比&emsp;</b>`
            );
          }
        });

        _.tableData = res.data.data.content || [];

        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    bindClick(row, e) {
      if (e.target.localName == "a") {
        console.log(1);
        this.$router.push({
          path: "/pileList",
          query: {
            pileCodes: row.noOrderPileCode,
          },
        });
      }
      if (e.target.localName == "u") {
        console.log(2);
        this.$router.push({
          path: "/pileList",
          query: {
            pileCodes: row.noOrderPileCodeYoy,
          },
        });
      }
    },
    handleExport() {
      let _ = this;
      if (this.selections.length <= 0) {
        utils.error("请选择需要操作的记录");
        return;
      } else {
        _.$U.showLoading(_);

        let arr = [];
        _.selections.forEach((item) => {
          arr.push(item.staticId);
        });
        let obj = {};
        obj.staticId = arr.join(",");
        _.$H
          .post(_, _.$A.pileStation.export, JSON.stringify(obj))
          .then((res) => {
            let filePath = res.data.data.filePath.slice(4);

            var downUrl = "http://ocharge.shzhida.com:6777" + filePath;

            window.open(downUrl, "_blank");

            _.$U.hideLoading(_);
            _.$message.success("导出成功");
          });
      }
    },

    reset() {
      this.pagination.current = 1;
      this.searchTime = [];
      delete this.queryInfo.stationName;
      delete this.queryInfo.dtFrom;
      delete this.queryInfo.dtTo;
      delete this.queryInfo.isHostOperate;
      delete this.queryInfo.dealName;
      this.tableData = [];
      this.pagination.total = 0;
    },
  },

  mounted() {
    this.init();
  },
};
</script>
